// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__21EYG","productName":"Table_productName__rQkbU"};